import styled from 'styled-components';

export const ContainerPage = styled.div`
  padding: ${(props) => (props.isHome ? '10px 10px 0 10px' : '10px 10px 50px 10px')};
`;
